import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN, pipe } from '@blade/std-lib'
import { Button, Skeleton } from '@blade/ui-kit'
import { basicAvailableUsdAtom, formatUsd } from '@root/entities/basic'
import { useTranslation } from '@root/shared/localization'

import { openBasicDepositDialogAction } from '../../basic-deposit'

/**
 * The top bar in Basic: what can be spent, and a way to add to it.
 *
 * It replaces the wallet picker, the SOL balance and the fee readouts, all of
 * which describe money Basic does not trade from. Showing them beside a
 * dollar balance invites the question which of the two a buy will spend —
 * and in Basic the answer is always the dollars.
 */
export const BasicTopbarCash: React.FC = () => {
  const { t } = useTranslation()
  const [available] = useAtom(basicAvailableUsdAtom)
  const openDeposit = useAction(openBasicDepositDialogAction)

  const amount = pipe(
    available,
    AsyncStateN.getOrElseW(() => undefined),
  )

  return (
    <Root>
      <Cash>
        {amount === undefined ? (
          <Skeleton width={48} height={14} />
        ) : (
          formatUsd(amount)
        )}
      </Cash>
      <DepositButton
        variant="solid"
        color="primary"
        size="xxs"
        radius="full"
        onClick={() => openDeposit()}
      >
        {t('basic.deposit_more')}
      </DepositButton>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 8px;
  height: 30px;
  padding-inline: 10px 3px;

  background: var(--background-3);
  border-radius: 15px;
`

const Cash = styled.span`
  color: var(--text-12);
  font-size: 13px;
  font-weight: 700;
  line-height: normal;
`

const DepositButton = styled(Button)`
  height: 24px;
  padding-inline: 10px;
`
